import {useNavigate, useParams, useLocation} from 'react-router-dom'
import {HeaderTitle} from '../../../../../common/HeaderTitle.jsx'
import ButtonWithIcon from '../../../../../common/ButtonWithIcon.jsx'
import {Icons} from '../../../../../common/Icons.jsx'
import Wizard from '../../../../../common/wizard/Wizard.jsx'
import {
    DanePodstawowe,
    Finansowanie,
    HarmonogramRealizacji,
    Kontakt,
    Ryzyka,
    Podsumowanie,
    Start
} from '../../../lib/components/sprawozdanieForm/s1/pages/index.js'
import {useSelector} from 'react-redux'
import {useState} from 'react'
import {ModalInfoProjekt} from '../../../lib/components/modals.jsx'

const ViewSprawozdanieForm = () => {
    const WZOR_NAME = 's1'
    const {rejestrId, sprawozdanieId, tryb} = useParams()
    const rola = useSelector((state) => state.user.role)
    const rolaParam = rola === 'oper' ? 'oper/' : '/'
    const navigate = useNavigate();
    const location = useLocation();
    const backTo = location.state?.from ?? `/${rola}/rejestr/lista`

    const wersja = sprawozdanieId ? `/${sprawozdanieId}` : ''
    const dataUrl = `${rolaParam}sprawozdanie/${rejestrId}${wersja}`
    const [showInfoModal, setShowInfoModal] = useState(false)

    return (
        <>
            <ModalInfoProjekt
                show={showInfoModal}
                handleClose={() => setShowInfoModal(false)}
                rejestrId={rejestrId}
            />
            <HeaderTitle
                home
                nav
                size={'fs-2'}
                breadcrumbLinks={[
                    {
                        label: 'Wszystkie projekty',
                        to: `/${rola}/rejestr/lista`,
                    },
                    {label: 'Podgląd sprawozdania'},
                ]}
                destination={backTo}
                data={[['ID', rejestrId]]}
                title={'Podgląd sprawozdania'}
            />
            <div className="d-flex justify-content-end mb-3 pe-3">
                <ButtonWithIcon
                    icon={<Icons.info size={20}/>}
                    onClick={() => setShowInfoModal(true)}
                    variant={'info'}
                    text={'Informacje o projekcie'}
                    className="text-white"
                />
            </div>
            <Wizard
                debug
                mode={tryb}
                name={WZOR_NAME}
                dataUrl={dataUrl}
                validationUrl={`${rolaParam}sprawozdanie/${rejestrId}${wersja}/podsumowanie`}
                saveUrl={`${rolaParam}sprawozdanie`}
                mappingUrl={`${rolaParam}sprawozdanie/wzor/${WZOR_NAME}`}
                //acceptButtons={acceptButtons}
                saveOnPageChange={true}
                stateForPage={false}
                saveAndQuitCallback={() => navigate(-1)}
                cancelCallback={() => navigate(-1)}
                filterByCategory={false}
                pages={[
                    {name: 'start', form: <Start/>},
                    {name: 'dane_podstawowe', form: <DanePodstawowe/>},
                    {name: 'finansowanie', form: <Finansowanie/>},
                    {name: 'harmonogram_realizacji', form: <HarmonogramRealizacji/>},
                    {name: 'ryzyka', form: <Ryzyka/>},
                    {name: 'kontakt', form: <Kontakt/>},
                    {
                        name: 'podsumowanie',
                        form: <Podsumowanie/>,
                        summary: true,
                    },
                ]}
            />
        </>
    )
}

export default ViewSprawozdanieForm
